export class FormMapaATControlNames {

    public static datePublication = '_SepSep_AttributionFromMAPA_SepSep_AvisInitialType_SepAtt_datePublication';

    public static montantIndefini = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepAtt_montantIndefini';
    public static valeur = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeMontant_SepAtt_valeur';
    public static monnaie = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeMontant_SepAtt_devise';
    public static offreBasse = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_Offres_SepAtt_offreBasse';
    public static offreElevee = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_Offres_SepAtt_offreElevee';
    public static monnaieFourchette = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_Offres_SepAtt_devise';

    public static valeurSsTraitance = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_valeur';
    public static monnaieSsTraitance = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_devise';
    public static pourcentageSsTraitance = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partPct';
    public static inconnueSsTraitance = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partInconnue';

    public static valeurSsTraitanceIndex = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_valeur';
    public static monnaieSsTraitanceIndex = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepSep_TypeMontant_SepAtt_devise';
    public static pourcentageSsTraitanceIndex = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partPct';
    public static inconnueSsTraitanceIndex = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_INDEX_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_SousTraitanceOui_SepAtt_partInconnue';

    public static dateAttribution = '_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR_SepAtt_dateAttribution';

    public static attribue = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepAtt_infructueux';

    public static critereLibre = '_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_SepAtt_critereLibre';


    public static getCtrl_446Names_json(): any {
        const dateFinDiffusion = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
        return { dateFinDiffusion, datePublication: FormMapaATControlNames.datePublication };
    }

    public static getCtrl_439Names_json(): any {
        return { datePublication: FormMapaATControlNames.datePublication };
    }

    public static getCtrl_1169Names_json(): any {
        const firstChamp = '_SepSep_Annonce_index_1_SepSep_TypeAnn_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
        return { firstChamp };
    }

    public static getCtrl_28_1Names_json(): any {
        const critere = '_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_index_INDEX_28_1_SepSep_CriterePondere_SepAtt_critere';
        const criterePoids = '_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_index_INDEX_28_1_SepSep_CriterePondere_SepAtt_criterePCT';

        return { critere, criterePoids };
    }

    public static getCtrl_28_2Names_json(): any {
        return { critereLibre: FormMapaATControlNames.critereLibre };
    }

    public static getCtrl_1162Names_json(): any {
        const criterePCT = '_SepSep_AttributionFromMAPA_SepSep_TypeCrJugement_index_INDEX_1162_1_SepSep_CriterePondere_SepAtt_criterePCT';

        return { criterePCT };
    }

    public static getCtrl_331_1Names_json(): any {
        return {
            montantIndefini: FormMapaATControlNames.montantIndefini,
            valeur: FormMapaATControlNames.valeur,
            monnaie: FormMapaATControlNames.monnaie,
            offreBasse: FormMapaATControlNames.offreBasse,
            offreElevee: FormMapaATControlNames.offreElevee,
            monnaieFourchette: FormMapaATControlNames.monnaieFourchette,
        };
    }

    public static getCtrl_331_2Names_json(lotMarcheIter): any {
        const montantIndefini = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_' + lotMarcheIter + '_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepAtt_montantIndefini';
        const valeur = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_' + lotMarcheIter + '_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeMontant_SepAtt_valeur';
        const monnaie = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_' + lotMarcheIter + '_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeMontant_SepAtt_devise';
        const offreElevee = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_' + lotMarcheIter + '_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_Offres_SepAtt_offreElevee';
        const offreBasse = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_' + lotMarcheIter + '_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_Offres_SepAtt_offreBasse';
        const monnaieFourchette = '_SepSep_AttributionFromMAPA_SepSep_Attribution_index_' + lotMarcheIter + '_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_Offres_SepAtt_devise';
        return { montantIndefini, valeur, monnaie, offreBasse, offreElevee, monnaieFourchette };
    }

    public static getCtrl_334Names_json(index = 0): any {
        return index == 0 ? {
            valeur: FormMapaATControlNames.valeurSsTraitance,
            monnaie: FormMapaATControlNames.monnaieSsTraitance,
            pourcentage: FormMapaATControlNames.pourcentageSsTraitance,
            inconnue: FormMapaATControlNames.inconnueSsTraitance
        } : {
            valeur: FormMapaATControlNames.valeurSsTraitanceIndex.replace("INDEX", index.toString()),
                monnaie: FormMapaATControlNames.monnaieSsTraitanceIndex.replace("INDEX", index.toString()),
                pourcentage: FormMapaATControlNames.pourcentageSsTraitanceIndex.replace("INDEX", index.toString()),
                inconnue: FormMapaATControlNames.inconnueSsTraitanceIndex.replace("INDEX", index.toString())
        };
    }

    public static getCtrl_426Names_json(datePublication): any {
        return { dateAttribution: FormMapaATControlNames.dateAttribution,
                 datePublication: datePublication};
    }

    public static getCtrl_427Names_json(): any {
        return { dateAttribution: FormMapaATControlNames.dateAttribution };
    }

    public static getCtrl_429Names_json(): any {
        return { attribue: FormMapaATControlNames.attribue, dateAttribution: FormMapaATControlNames.dateAttribution };
    }
}
